export const routes = {
	welcome: '/',
	documentation: `/documentation`,
	developerPortal: `/developer-portal`,

	signIn: '/login',
	signUp: '/registration',
};